"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKFLOW = exports.WORDPRESS = exports.WEBSITE = exports.WEBINAR = exports.VIDEO = exports.TICKETING = exports.SURVEY = exports.SOCIAL = exports.SEO = exports.SCHEDULING = exports.SALES = exports.PROJECT = exports.PPC = exports.PAYROLL = exports.LIVE_CHAT = exports.LEAD_GEN = exports.KNOWLEDGE_BASE = exports.IPAAS = exports.HELP_DESK = exports.EVENT = exports.ERP = exports.EMAIL = exports.ECOMMERCE = exports.DATA_MANAGEMENT = exports.CRM = exports.CMS = exports.CALL_CENTER = exports.AUTOMATION = exports.ANALYTICS = exports.ACCOUNTING = exports.ABM = void 0;
var ABM = 'abm';
exports.ABM = ABM;
var ACCOUNTING = 'accounting';
exports.ACCOUNTING = ACCOUNTING;
var ANALYTICS = 'analytics-data';
exports.ANALYTICS = ANALYTICS;
var AUTOMATION = 'marketing-automation';
exports.AUTOMATION = AUTOMATION;
var CALL_CENTER = 'calling';
exports.CALL_CENTER = CALL_CENTER;
var CMS = 'cms';
exports.CMS = CMS;
var CRM = 'crm';
exports.CRM = CRM;
var DATA_MANAGEMENT = 'data-management';
exports.DATA_MANAGEMENT = DATA_MANAGEMENT;
var ECOMMERCE = 'ecommerce';
exports.ECOMMERCE = ECOMMERCE;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var ERP = 'erp';
exports.ERP = ERP;
var EVENT = 'events';
exports.EVENT = EVENT;
var HELP_DESK = 'help-desk';
exports.HELP_DESK = HELP_DESK;
var IPAAS = 'connector';
exports.IPAAS = IPAAS;
var KNOWLEDGE_BASE = 'knowledge-base';
exports.KNOWLEDGE_BASE = KNOWLEDGE_BASE;
var LEAD_GEN = 'lead-generation';
exports.LEAD_GEN = LEAD_GEN;
var LIVE_CHAT = 'live-chat';
exports.LIVE_CHAT = LIVE_CHAT;
var PAYROLL = 'payroll';
exports.PAYROLL = PAYROLL;
var PPC = 'advertising';
exports.PPC = PPC;
var PROJECT = 'project-management';
exports.PROJECT = PROJECT;
var SALES = 'sales-enablement';
exports.SALES = SALES;
var SCHEDULING = 'scheduling';
exports.SCHEDULING = SCHEDULING;
var SEO = 'seo';
exports.SEO = SEO;
var SOCIAL = 'social-media';
exports.SOCIAL = SOCIAL;
var SURVEY = 'survey';
exports.SURVEY = SURVEY;
var TICKETING = 'ticketing';
exports.TICKETING = TICKETING;
var VIDEO = 'video';
exports.VIDEO = VIDEO;
var WEBINAR = 'webinar';
exports.WEBINAR = WEBINAR;
var WEBSITE = 'website-builder';
exports.WEBSITE = WEBSITE;
var WORDPRESS = 'wordpress';
exports.WORDPRESS = WORDPRESS;
var WORKFLOW = 'workflow-automation';
exports.WORKFLOW = WORKFLOW;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/urlSlugs/CategorySlug.js
// module id = 112
// module chunks = 209 210 211 212 213